import React from 'react';

import { Stack, Typography } from '@lyearn/ui';
import contentConfig from '@/modules/content/config';
import renderImage from '@/modules/content/utils/renderImage';
import { ContentEntity, ResourceTypeEnum } from '@/types/schema';

import { BaseItemProps } from '../../types';

const IMAGE_SIZE = 36;

const BaseContentItem: React.FC<BaseItemProps<ContentEntity>> = (props) => {
  const { item, overrides } = props;
  const { name, type } = item;

  const { image } = contentConfig[type as ResourceTypeEnum]?.icons?.getContentImage(item)!;

  return (
    <>
      {renderImage({
        image,
        contentName: name,
        className: 'flex',
        width: overrides?.Image?.size || IMAGE_SIZE,
        height: overrides?.Image?.size || IMAGE_SIZE,
      })}
      <Stack className="overflow-hidden ms-12" direction="col">
        <Typography className="truncate" color="text-text-primary" variant="body-short-02">
          {name}
        </Typography>
        <Typography
          className="mt-2 capitalize"
          color={'text-text-secondary'}
          variant="body-short-03">
          {type.toLowerCase()}
        </Typography>
      </Stack>
    </>
  );
};

export default BaseContentItem;
